const normalizeQuestionId = (questionId) =>
  String(questionId || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const isPhoneQuestion = (questionId) =>
  ["phone", "phonenumber", "phonenum", "telephone"].includes(
    normalizeQuestionId(questionId)
  );

export const isGraduationYearQuestion = (questionId) =>
  ["graduationyear", "graduatingyear", "gradyear", "yearofgraduation"].includes(
    normalizeQuestionId(questionId)
  );

export const getGraduationYearQuestionLocation = (sections) => {
  const questions = sections.flatMap((section, sectionIndex) =>
    section.questions.map((question, questionIndex) => ({
      question,
      sectionIndex,
      questionIndex,
    }))
  );

  return (
    questions.find(
      ({ question }) =>
        isGraduationYearQuestion(question.question_id) &&
        question.question_type === "multiple_choice"
    ) ||
    questions.find(({ question }) =>
      isGraduationYearQuestion(question.question_id)
    )
  );
};

export const shouldDisplayCycleQuestion = (
  question,
  sectionIndex,
  questionIndex,
  graduationYearQuestionLocation
) => {
  if (isPhoneQuestion(question.question_id)) return false;
  if (!isGraduationYearQuestion(question.question_id)) return true;

  return (
    graduationYearQuestionLocation?.sectionIndex === sectionIndex &&
    graduationYearQuestionLocation?.questionIndex === questionIndex
  );
};

export const getProfileFieldUpdate = (questionId, value) =>
  isGraduationYearQuestion(questionId) ? { graduation_year: value } : {};

export const getGraduationYearValue = (sections, savedValue = "") =>
  savedValue ||
  sections
    .flatMap((section) => section.answers)
    .find(
      (answer) =>
        isGraduationYearQuestion(answer.question_id) && answer.answer
    )?.answer ||
  "";
